// Composables
import { createRouter, createWebHistory } from 'vue-router'
import { useLoginStore, useAnalyticsStore, useInitStore, useAppGlobalStore } from '@/store/app'
import { setCurrentScene } from '@/services/analytics'

const routes = [
  {
    path: '/profiles',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '',
        name: 'ProfilesOld',
        // route level code-splitting
        // this generates a separate chunk (ProfilesView-[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/ProfilesView.vue')
      }
    ],
    meta: { requiresAuth: true } // Indica que se requiere autenticación
  },
  {
    path: '/session',
    component: () => import('@/layouts/LayoutV2/LayoutV2.vue'),
    children: [
      {
        path: '',
        name: 'Session',
        // route level code-splitting
        // this generates a separate chunk (SessionView-[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/SessionView.vue')
      }
    ],
    meta: { requiresAuth: true, title: 'routes.createSession' } // Indica que se requiere autenticación
  },
  /* {
    path: '/games',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '',
        name: 'Games',
        // route level code-splitting
        // this generates a separate chunk (StepperView-[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/StepperView.vue')
      }
    ],
    meta: { requiresAuth: true } // Indica que se requiere autenticación
  }, */
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginNewView.vue')
  },
  {
    path: '/onboarding',
    children: [
      {
        path: '',
        name: 'Onboarding',
        // route level code-splitting
        // this generates a separate chunk (OnboardingView-[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/OnboardingView.vue')
      }
    ]
  },
  {
    path: '/profile-old',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '',
        name: 'ProfileOld',
        // route level code-splitting
        // this generates a separate chunk (ProfileView-[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/ProfileView.vue')
      }
    ],
    meta: { requiresAuth: true } // Indica que se requiere autenticación
  },
  {
    path: '/activities',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '',
        name: 'Activities',
        // route level code-splitting
        // this generates a separate chunk (ActivitiesView-[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/ActivitiesView.vue')
      }
    ],
    meta: { requiresAuth: true } // Indica que se requiere autenticación
  },
  {
    path: '/edit-profile-old',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '',
        name: 'ProfileEditOld',
        // route level code-splitting
        // this generates a separate chunk (ProfileEditView-[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/ProfileEditView.vue')
      }
    ],
    meta: { requiresAuth: true } // Indica que se requiere autenticación
  },
  {
    path: '/session-created',
    component: () => import('@/layouts/LayoutV2/LayoutV2.vue'),
    children: [
      {
        path: '',
        name: 'SessionCreated',
        component: () => import('@/views/SessionCreatedView.vue')
      }
    ],
    meta: {
      requiresAuth: true,
      title: 'routes.sessionCreated'
    }
  },
  {
    path: '/plans',
    component: () => import('@/layouts/LayoutV3/LayoutV3.vue'),
    children: [
      {
        path: '',
        name: 'Plans',
        component: () => import('@/views/PlansView.vue')
      }
    ],
    meta: {
      requiresAuth: true,
      title: 'routes.plans'
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/LayoutV3/LayoutV3.vue'),
    children: [
      {
        path: '',
        name: 'Profiles',
        component: () => import('@/views/HomeView.vue')
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/onboard',
    component: () => import('@/layouts/LayoutV3/LayoutV3.vue'),
    children: [
      {
        path: '',
        name: 'Onboard',
        component: () => import('@/views/OnboardView.vue')
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/edit-profile',
    component: () => import('@/layouts/LayoutV2/LayoutV2.vue'),
    children: [
      {
        path: '',
        name: 'ProfileEdit',
        component: () => import('@/views/EditProfileView.vue')
      }
    ],
    meta: {
      requiresAuth: true,
      title: 'routes.editProfile'
    }
  },
  {
    path: '/profile',
    component: () => import('@/layouts/LayoutV3/LayoutV3.vue'),
    children: [
      {
        path: '',
        name: 'Profile',
        component: () => import('@/views/UserProfileView.vue')
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/faqs',
    component: () => import('@/layouts/LayoutV3/LayoutV3.vue'),
    children: [
      {
        path: '',
        name: 'Faq',
        component: () => import('@/views/FaqView.vue')
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/professional-profile',
    component: () => import('@/layouts/LayoutV3/LayoutV3.vue'),
    children: [
      {
        path: '',
        name: 'ProfessionalProfile',
        component: () => import('@/views/ProfessionalProfileView.vue')
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/payment-successful',
    component: () => import('@/layouts/LayoutV2/LayoutV2.vue'),
    children: [
      {
        path: '',
        name: 'PaymentSuccesful',
        component: () => import('@/views/PaymentSuccessfulView.vue')
      }
    ],
    meta: {
      requiresAuth: true,
      title: 'routes.subscriptionActivated'
    }
  },
  {
    path: '/payment-error',
    component: () => import('@/layouts/LayoutV2/LayoutV2.vue'),
    children: [
      {
        path: '',
        name: 'PaymentError',
        component: () => import('@/views/PaymentErrorView.vue')
      }
    ],
    meta: {
      requiresAuth: true,
      title: 'routes.operationCanceled'
    }
  },
  {
    path: '/maintenance',
    component: () => import('@/layouts/LayoutV2/LayoutV2.vue'),
    children: [
      {
        path: '',
        name: 'Maintenance',
        component: () => import('@/views/MaintenanceView.vue')
      }
    ],
    meta: {
      requiresAuth: false,
      title: 'routes.maintenance'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const isUserAuthenticated = () => {
  const loginStore = useLoginStore()
  return loginStore.token != ''
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const analyticsStore = useAnalyticsStore()
  const loginStore = useLoginStore()

  if (Object.keys(to.query).length > 0) {
    analyticsStore.setQueryParams(to.query)
  }

  const hasUTMs = Object.keys(analyticsStore.queryParams).every(
    (key) => to.query[key] === analyticsStore.queryParams[key]
  )

  const customToken = to.query['customToken']?.toString()
  if (customToken != null && customToken != '' && customToken != loginStore.customToken) {
    loginStore.setCustomToken(customToken)
    await loginStore.signInWithCustomToken()
  }

  const isMaintenanceMode = false
  if (isMaintenanceMode && to.name !== 'Maintenance') {
    next({ name: 'Maintenance', query: analyticsStore.queryParams })
  } else if (to.name !== 'Login' && to.name !== 'Maintenance' && !isUserAuthenticated()) {
    const appGlobalStore = useAppGlobalStore()
    appGlobalStore.setRedirect(to.path)
    next({ name: 'Login', query: analyticsStore.queryParams })
  } else if (!hasUTMs && to.name !== 'Maintenance') {
    next({ ...to, query: analyticsStore.queryParams })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  console.log(to)
  console.log(from)
  const appGlobalStore = useAppGlobalStore()
  appGlobalStore.addPageToHistory(to)
  const analyticsStore = useAnalyticsStore()
  setCurrentScene({ to, from, source: analyticsStore.source })
})

export default router
